import resmap from '../data/resdict.json';
import {genSVG} from '../glycan-interpreter/parser';

//Window utils for glycan visualizer.

/**
 * Handle residue symbol adding from symbol list.
 * @param {*} resname 
 */
export function clickToAddSymbol(resname, nodes, offset)
{
    let symbolMapping = null;
    let img_selected, img_unselected;

    //get the shape and colour from the residue map
    if (resname in resmap){               
        symbolMapping = resmap[resname];      
    }

    //populate the image if it's in the list
    if(symbolMapping)
    {
        img_selected = genSVG(symbolMapping.shape, symbolMapping.colour, false, true, true);
        img_unselected = genSVG(symbolMapping.shape, symbolMapping.colour, false, true);
    } else {
        img_selected = genSVG("missing", "white", false, true, true);
        img_unselected = genSVG("missing", "white", false, true);
    }
    
    //get the offset for the nodes list
    const nodesIDList = nodes.map(node => node.id);
    const idOffset = nodesIDList.length > 0 ? Math.max(...nodesIDList) + 2 : 0;
    const newNode = {id:idOffset,shape_map:symbolMapping.shape, 
        colour_map:symbolMapping.colour, x:offset.x, y:offset.y, 
        nodeType:'shape', shape:"image", 
        image:{unselected: img_unselected.img, selected:img_selected.img}, 
        svg:img_unselected.svg, shapeProperties:{borderDashes:[15,5], interpolation:false, residue:resname}};
    return newNode;
}